// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"9ad59354","232":"9ad59354","365":"9ad59354","409":"9ad59354","541":"9ad59354","644":"9ad59354","807":"9ad59354"}[chunkId] + ".chunk.css";
};